import { window } from '../../../../../../../globals';
import { Action, ResourceType, useHasPermission } from '../../../../../../../shared/permissions';

/**
 * Hook for managing permissions for saved options.
 */
export const useSavedOptionsPermissions = () => {
  const hasPermission = useHasPermission();

  const userTeams = window.user?.teams || [];

  // For each permission type we first check if the user has the permission for the organization scope, which
  // requires only a single look up. In cases where they don't, we'll iterate through their teams to verify if they
  // have permissions through any one of them.

  const canDeleteAny = hasPermission({
    resourceType: ResourceType.ReportOptionAny,
    action: Action.Delete,
  });
  const isUserOnTeamWithDeletePermission = !canDeleteAny && userTeams.some((team) =>
    hasPermission({
      resourceType: ResourceType.TeamReportOptionAny,
      action: Action.Delete,
      teamId: team.id,
    }),
  );
  const canDelete = canDeleteAny || isUserOnTeamWithDeletePermission;

  const canCreateAny = hasPermission({
    resourceType: ResourceType.ReportOptionAny,
    action: Action.Create,
  });
  const isUserOnTeamWithCreatePermission = !canCreateAny && userTeams.some((team) =>
    hasPermission({
      resourceType: ResourceType.TeamReportOptionAny,
      action: Action.Create,
      teamId: team.id,
    }),
  );
  const canCreate = canCreateAny || isUserOnTeamWithCreatePermission;

  const canEditAny = hasPermission({
    resourceType: ResourceType.ReportOptionAny,
    action: Action.Edit,
  });
  const isUserOnTeamWithEditPermission = !canEditAny && userTeams.some((team) =>
    hasPermission({
      resourceType: ResourceType.TeamReportOptionAny,
      action: Action.Edit,
      teamId: team.id,
    }),
  );
  const canEdit = canEditAny || isUserOnTeamWithEditPermission;

  return {
    canDelete,
    canCreate,
    canEdit,
  };
};
